// eslint-disable-next-line no-shadow
export var CustomTextColor = /*#__PURE__*/function (CustomTextColor) {
  CustomTextColor["LIGHT"] = "customLight";
  CustomTextColor["DARK"] = "customDark";
  return CustomTextColor;
}({});
/**
 * Adds opacity to custom hex color
 *
 * @returns hex custom color with opacity
 * @param hex - custom hex color
 * @param opacity - opacity value from 0 to 1
 */
var getHexColorWithOpacity = function getHexColorWithOpacity(hex, opacity) {
  var hexColor = hex.replace(/[\s+#]/g, "");
  var color = hexColor.length === 3 ? hexColor.replace(/(.)/g, "$1$1") : hexColor;
  var alpha = Math.round(opacity * 255);
  var hexColorWithAlpha = "".concat(color).concat(alpha.toString(16).padStart(2, "0"));
  return "#".concat(hexColorWithAlpha);
};

/**
 * Returns color (defined in theme object)
 *
 * @returns Color hex
 * @param customColor
 * @param opacity
 */
export var getCustomColor = function getCustomColor(customColor, opacity) {
  if (!customColor) {
    return null;
  }
  var colorValue;
  if (typeof customColor === "string") {
    colorValue = customColor;
    if (opacity) {
      colorValue = getHexColorWithOpacity(customColor, opacity);
    }
  } else {
    colorValue = "linear-gradient(".concat(customColor.start, ", ").concat(customColor.end, ")");
  }
  return colorValue;
};
export var getBackgroundByTextColor = function getBackgroundByTextColor(textColor) {
  if (textColor === CustomTextColor.LIGHT) {
    return "customDark";
  }
  if (textColor === CustomTextColor.DARK) {
    return "customLight";
  }
  return undefined;
};